/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-09-25 16:07:04
 * @lastTime     : 2020-02-15 13:43:06
 * @LastAuthor   : WE1ZHANTA0
 */
import YunJi from '@/common/js/YunJi'
import { isWxProgram } from './Util'

let pendingGetH5CacheList = false
let memoryCache = []

const url = globalConfig.h5CacheList


function projectFilter(res){
  if (res.data.errorCode == 2418 || res.data.code == 2418) {
    let currentUrl = window.location.href
    let title = currentUrl.indexOf("groupon") > -1 ? '云集拼团' : '云集'
    let returnUrl = ''     
    if (currentUrl.indexOf("groupon") > -1) { // 拼团
      returnUrl = '//' + globalConfig.linkPath + '/yunjigroupbuyapp/groupbuy/getVueUser.xhtml?returnUrl=' + encodeURIComponent(currentUrl+'&authorize=true')
    } else if(currentUrl.indexOf("paymentAfter") > -1 || currentUrl.indexOf("newPaymentAward") > -1) { // 云集福袋
      returnUrl = '//' + globalConfig.linkPath + '/yunjispecialbuyer/clickshare/getVueUser.xhtml?returnUrl=' + encodeURIComponent(currentUrl+'&authorize=true')
    } else if (currentUrl.indexOf('goldCoinswhisper') > -1) { // 金币搜搜搜
      returnUrl = '//' + globalConfig.linkPath + '/yunjispecialbuyer/skygroup/getVueUser.xhtml?returnUrl=' + encodeURIComponent(currentUrl+'&authorize=true')
    } else if (currentUrl.indexOf('Orgranize') > -1 || currentUrl.indexOf('fiveYearBill') > -1 || currentUrl.indexOf('viprecall') > -1) { // 组队任务/516账单/沉默召回
      returnUrl = '//' + globalConfig.linkPath + '/yunjiuseractivityapp/useractivityapp/teamTask/getVueUser.xhtml?returnUrl=' + encodeURIComponent(currentUrl+'&authorize=true')
    } else if (currentUrl.indexOf('shareprofits') > -1 ) { // 分享赚         
      returnUrl = '//' + globalConfig.sharePath + '/sharerevenueweb/app/sharerevenue/getVueUser.xhtml?returnUrl=' + encodeURIComponent(currentUrl+'&authorize=true')
    }
    try {
      var modal = new Modal({
        title: title,
        returnUrl: returnUrl
      })
    } catch (err) {
      window.location.href = returnUrl
    }
    
    return
  }
  if (res.data.errorCode == 1009 ) {
    location.href = 'yunji://shop/shopDetail/shopping?appCont=2'
    return
  }
  
  return res.data
}

export default function (axios) {
  axios.interceptors.request.use(function (config) {
    if (typeof localStorage === 'undefined') {
      return config
    }
    // 删除已经过期的缓存
    deleteCacheList()

    // 还没有获取h5CacheList 或者 h5CacheList 过期
    if (!getItem('h5CacheList')) {
      getConfigInfo()
    }
    let cacheObj = getItem(getCacheKey(config.baseURL + config.url, config.params))

    const appCont  = YunJi.getUrlParams('appCont') || ''
    // 对小程序入口进行处理
    if(appCont == '7' || isWxProgram()){
    // if(1){
      const ticket = YunJi.getUrlParams('ticket')|| '100'
      if(config.params){
        config.params.ticket = ticket
        config.params.appCont = appCont
      }
    }

    // 已经过期 或者 没有缓存
    if (!cacheObj) {
      return config
    }else {
      return Promise.reject({cacheObj, rejectForCache: true})
    }
  }, function (error) {
    return Promise.reject(error)
  });

  axios.interceptors.response.use(function (res) {
    if (typeof localStorage === 'undefined') {
      return res
    }

    if (res && (res.data.errorCode === 0 || res.data.errorCode === undefined)) {
      // 从配置信息中获取缓存时间
      let cacheTime = getCacheTime(res.config.url)
      let key = getCacheKey(res.config.url, res.config.params)
      let currentTime = Date.now()
      // 有缓存时间 一定是有h5CacheList
      if (cacheTime) {
        setItem(key, res)

        addCacheList(key, currentTime + cacheTime * 1000)
      } else {
        // 可能没有h5CacheList
        saveToMemoryCache({key, currentTime, res, url: res.config.url})
      }
    }     

    

    return projectFilter(res);
  }, function (error) {
    if (typeof error === 'object' && error !== null && error.rejectForCache === true) {
      return Promise.resolve(error.cacheObj.data)
    } else {
      return Promise.reject(error)
    }
  });

  // 删除过期的缓存
  function deleteCacheList() {
    let cacheExpireTime = getItem('cacheExpireTime') || {}
    let delFlag = false

    Object.keys(cacheExpireTime).forEach((key) => {
      if (cacheExpireTime[key] < Date.now()) {
        delFlag = true
        localStorage.removeItem(key)
        delete cacheExpireTime[key]
      }
    })

    if (delFlag) {
      setItem('cacheExpireTime', cacheExpireTime)
    }
  }

  // 获取缓存的键
  function getCacheKey(url, data = {}) {
    let str = '.com/'
    let base = url.substring(url.indexOf(str) + str.length)
    
    let arr = []
    for (let key in data) {
      if (key !== 'v' && key !== 't') {
        arr.push(key + '=' + data[key])
      }
    }

    let param = arr.join('&')
    let separator = base.indexOf('?') > -1 ? '&' : '?'
    return param ? (base + separator + param) : base
  }

  // 获取缓存时间
  function getCacheTime(url) {
    let h5CacheList = getItem('h5CacheList')
    if (h5CacheList) {
      // 遍历所有的data对象
      for (let key in h5CacheList) {
        //  如果能包含一个键就返回值
        if (url.indexOf(key) > -1) {
          return parseInt(h5CacheList[key]) || 0
        }
      }
      return 0
    } else {
      return 0
    }
  }

  // 添加缓存list
  function addCacheList(cacheKey, cacheTime) {
    let cacheExpireTime = getItem('cacheExpireTime') || {}

    cacheExpireTime[cacheKey] = cacheTime

    setItem('cacheExpireTime', cacheExpireTime)
  }

  // 获取h5CacheList和其他接口同时发起 如果其他接口先返回就先存一下 等h5CacheList返回时在缓存到localStorage
  function saveToMemoryCache({key, currentTime, res, url}){
    // 如果已经有了h5CacheList 什么都不做
    // 还没有h5CacheList的时候 就先放在数组中 memoryCache内存缓存 逼格高
    if (!getItem('h5CacheList')) {
      memoryCache.push({key, currentTime, res, url})
    }
  }

  function getItem(key) {
    let value = null;
    try {
      value = localStorage.getItem(key);
    } catch (e) {
      localStorage.removeItem(key);
    }
    if (!value) {
      return null;
    }
    try {
      value = JSON.parse(value);
    } catch (e) {
      localStorage.removeItem(key);
      value = null;
    }
    return value;
  }

  function setItem(key, value) {
    if (typeof value !== 'string') {
      try {
        value = JSON.stringify(value)
      } catch (e) {
        return
      }
    }

    try {
      localStorage.setItem(key, value)
    } catch (e) {
      if (e.name === 'QuotaExceededError') {
        localStorage.clear();
      }
    }
  }


  // 获取配置信息
  function getConfigInfo() {
    if (pendingGetH5CacheList) {
      return
    }
    pendingGetH5CacheList = true
    axios.get(url, {withCredentials: false, params: {t: Date.now()}}).then(res => {
      pendingGetH5CacheList = false
      // 如果没有设置 h5CacheList.json的过期时间 就设置一个默认的
      res.h5CacheList = res.h5CacheList || '60'
      // 缓存配置信息
      setItem('h5CacheList', res)

      addCacheList('h5CacheList', Date.now() + parseInt(res.h5CacheList) * 1000)

      let h5CacheList = res
      // 是否有比h5CacheList返回快的  遍历一遍存一下
      memoryCache.forEach((cacheItem) => {
        let {key, currentTime, res, url} = cacheItem

        for (let h5CacheListKey in h5CacheList) {
          //  如果能包含一个键就返回值
          if (url.indexOf(h5CacheListKey) > -1 && (res.data && (res.data.errorCode === 0 || res.data.errorCode === undefined))) {   // ajax请求的 要么没有errorCode 有必须不为0
            setItem(key, res)

            addCacheList(key, currentTime + parseInt(h5CacheList[h5CacheListKey]) * 1000)
            break
          }
        }
      })
      // 清除缓存
      memoryCache.length = 0
    }).catch(e => {
      pendingGetH5CacheList = false
    })
  }

}
